import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { EmailShareButton } from "react-share";
import { format } from "date-fns";
import VaModal from "../ui/va-modal/va-modal";
import { GmailIcon } from "@/icons/gmail-icon";
import { IconContainer, EmailContainer, } from "./ShareFullTableModalStyle";
const ShareFullTableModal = ({ visible, setVisible, modalClosed = () => { }, tableId = "", jdName = "", interview, mode }) => {
    const statusMeta = {
        completed: { icon: "✅", label: "Completed" },
        pass: { icon: "✅", label: "Pass" },
        fail: { icon: "❌", label: "Fail" },
        "in-progress": { icon: "⏳", label: "In Progress" },
        expired: { icon: "⚠️", label: "Expired" },
        scheduled: { icon: "🕒", label: "Scheduled" },
    };
    const formatName = (name) => name === null || name === void 0 ? void 0 : name.split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1).toLowerCase()).join(" ");
    const [tableBlobUrl, setTableBlobUrl] = useState("");
    // 🔹 Generate table HTML without Actions column
    const getTableHTMLForShare = (tableId) => {
        const table = document.getElementById(tableId);
        if (!table)
            return "";
        const clone = table.cloneNode(true);
        // Remove last column (Actions)
        const headers = clone.querySelectorAll("thead tr th");
        if (headers.length)
            headers[headers.length - 1].remove();
        const rows = clone.querySelectorAll("tbody tr");
        rows.forEach((row) => {
            const cells = row.querySelectorAll("td");
            if (cells.length)
                cells[cells.length - 1].remove();
        });
        return clone.outerHTML;
    };
    const getSingleInterviewText = (interview) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const formatDate = (d) => d ? format(new Date(d), "PPP p") : "-";
        const statusKey = (_b = (_a = interview === null || interview === void 0 ? void 0 : interview.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.replace(" ", "-");
        const statusMeta = {
            completed: "✅ Completed",
            pass: "✅ Pass",
            fail: "❌ Fail",
            "in-progress": "⏳ In Progress",
            expired: "⚠️ Expired",
            scheduled: "🕒 Scheduled",
        };
        const divider = "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━";
        const subDivider = "────────────────────";
        const assessment = ((_c = interview === null || interview === void 0 ? void 0 : interview.final_report) === null || _c === void 0 ? void 0 : _c.reason) || "-";
        const proctoring = ((_e = (_d = interview === null || interview === void 0 ? void 0 : interview.final_report) === null || _d === void 0 ? void 0 : _d.evaluation_of_cheating_detection) === null || _e === void 0 ? void 0 : _e.summary) || "-";
        const intro = `Dear User,

Please see below the candidate (${formatName(interview === null || interview === void 0 ? void 0 : interview.interviewee_name)})'s result summary for the JD "${jdName}".

`;
        const signature = `

 Regards,`;
        return `
    ${intro}
${divider}
📄 Interview Report
${divider}

👤 Candidate Information
${subDivider}
Candidate Name              : ${(_f = interview === null || interview === void 0 ? void 0 : interview.interviewee_name) !== null && _f !== void 0 ? _f : "-"}
Candidate Email             : ${(_g = interview === null || interview === void 0 ? void 0 : interview.interviewee_email) !== null && _g !== void 0 ? _g : "-"}

🗓 Interview Timeline
${subDivider}
Scheduled On   : ${formatDate(interview === null || interview === void 0 ? void 0 : interview.valid_from)}
Start Time        : ${formatDate(interview === null || interview === void 0 ? void 0 : interview.started_at)}
End Time          : ${formatDate(interview === null || interview === void 0 ? void 0 : interview.ended_at)}

📊 Result Summary
${subDivider}
Status            : ${(_j = (_h = statusMeta[statusKey]) !== null && _h !== void 0 ? _h : interview === null || interview === void 0 ? void 0 : interview.status) !== null && _j !== void 0 ? _j : "-"}
Final Score       : ${(_l = (_k = interview === null || interview === void 0 ? void 0 : interview.final_report) === null || _k === void 0 ? void 0 : _k.final_score) !== null && _l !== void 0 ? _l : "-"}
Passing Score     : ${(_o = (_m = interview === null || interview === void 0 ? void 0 : interview.final_report) === null || _m === void 0 ? void 0 : _m.passing_score) !== null && _o !== void 0 ? _o : "-"}

📝 Assessment Summary
${subDivider}
${assessment}

🔍 Proctoring Summary
${subDivider}
${proctoring}

${signature}
`.trim();
    };
    const getStyledInterviewReport = (tableId) => {
        const table = document.getElementById(tableId);
        if (!table)
            return "";
        const rows = Array.from(table.rows).slice(1);
        const divider = "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━";
        const subDivider = "────────────────────";
        const intro = `Dear User,

Please see below the candidate’s result summary for the JD "${jdName}".

`;
        const blocks = [];
        rows.forEach((row) => {
            const cells = Array.from(row.cells).map((c) => { var _a; return ((_a = c.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || "_"; });
            const [name, statusRaw, scheduled, start, end, score, passing, assessment, proctoring,] = cells;
            const statusKey = statusRaw.toLowerCase().replace(" ", "-");
            const status = statusMeta[statusKey] || {
                icon: "ℹ️",
                label: statusRaw,
            };
            blocks.push(`${divider}
👤 Candidate Name: ${name}
📌 Status    : ${status.icon} ${status.label}
🗓 Scheduled On : ${scheduled}
${start !== "_" && end !== "_" ? `⏱ Interview Duration  : ${start} – ${end}` : "-"}
📊 Score     : ${score !== "_" ? `${score}` : "-"}

📝 Assessment Summary
${subDivider}
${assessment || "-"}

🔍 Proctoring Summary
${subDivider}
${proctoring || "-"}`);
        });
        const signature = `

 Regards,`;
        // ${recruiterName}`;
        return `${intro}${blocks.join("\n\n")}${signature}`;
    };
    const emailBody = mode === "single"
        ? getSingleInterviewText(interview)
        : getStyledInterviewReport(tableId);
    // 🔹 Generate blob URL for email
    useEffect(() => {
        if (!visible)
            return;
        const html = getTableHTMLForShare(tableId);
        if (!html)
            return;
        const blob = new Blob([`<html><head><meta charset="UTF-8"></head><body>${html}</body></html>`], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        setTableBlobUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [visible, tableId]);
    return (_jsx(VaModal, { title: "Share Interview Report", visible: visible, setVisible: setVisible, modalClosed: modalClosed, children: _jsx(IconContainer, { children: _jsx(EmailShareButton, { subject: mode === "single"
                    ? `Interview Report of ${formatName(interview === null || interview === void 0 ? void 0 : interview.interviewee_name)} for ${jdName} Role`
                    : `Interview Reports for ${jdName} Role`, body: emailBody, url: "", children: _jsx(EmailContainer, { children: _jsx(GmailIcon, {}) }) }) }) }));
};
export default ShareFullTableModal;
